// @ts-check
import { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import styled from 'styled-components';
import Tooltip from '@material-ui/core/Tooltip';
import { Flex, Padding } from '../base/layout-components';
import Text from '../base/Text';
import { LINE_HEIGHT, SPACES } from 'common/constants/sizes';
import Icon from '../base/Icon';
import { getColor } from 'common/constants/_colors';
import { LBButton } from '@linearb/buzz';

const ButtonsList = ({ buttons }) =>
  buttons.map(({ buttonProps, text }, idx) => (
    <Padding {...(idx === 0 ? { r: 'small' } : {})} key={idx}>
      <LBButton variant='ghost' size='sm' {...buttonProps}>
        {text}
      </LBButton>
    </Padding>
  ));

const Wrapper = styled(Flex)`
  &:hover {
    background: ${getColor('catskillGray')};
  }
`;

const Notification = props => {
  const {
    notificationId,
    onRemoveClick = () => {},
    notificationAt,
    title = '',
    buttons = [],
    children
  } = props;
  const [isHover, setIsHover] = useState(false);

  return (
    <Wrapper
      direction='row'
      padding='medium'
      pb='no-space'
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <Flex pb='medium' width='100%'>
        <Flex direction='column' pl='small' width='100%'>
          <Text pb={SPACES['x-small']} color='shuttleGray'>
            {moment(notificationAt).calendar()}{' '}
          </Text>
          <Text
            pb='0.3rem'
            color='shuttleGray'
            size='medium'
            weight='bold'
            lineHeight={LINE_HEIGHT.medium}
          >
            {title}
          </Text>
          <Flex pb='small'>{children}</Flex>
          <Flex>
            <ButtonsList buttons={buttons} />
          </Flex>
        </Flex>

        <Flex {...(isHover ? {} : { style: { visibility: 'hidden' } })}>
          <Tooltip
            placement={'top-start'}
            title={'Remove notification for everyone'}
          >
            <span>
              <LBButton
                variant='ghost'
                size='icon'
                onClick={() => onRemoveClick(notificationId)}
              >
                <Icon
                  name='check'
                  size='small'
                  color={isHover ? 'dodgerBlue' : 'pigeonPost'}
                />
              </LBButton>
            </span>
          </Tooltip>
        </Flex>
      </Flex>
    </Wrapper>
  );
};

Notification.propTypes = {
  color: PropTypes.string,
  onRemoveClick: PropTypes.func,
  onPinClick: PropTypes.func,
  notificationAt: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  icon: PropTypes.element,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      buttonProps: PropTypes.object
    })
  )
};

export default Notification;
